import React, { Component } from "react";
import View from "./view";
import { withRouter } from "react-router-dom";
import { searchStores, searchBranches} from "../../backend/stores";
import { sendTool} from "../../backend/machine";

class SendTool extends Component {
  constructor(props) {
    super(props);
    this.state = {
      courierNumber: this.props.match.params.courier !== "" ? this.props.match.params.courier : '',
      courierNumber2: this.props.match.params.courierNumber !== "" ? props.match.params.courierNumber : '',
      showCourier: true,
      storeId: "",
      storeName:"",
      branchId: "",
      branchRecordId:"",
      toolId: props.match.params.id,
      //bag_id : "",
      assignSuccess: false,
      errMsg: "",
      machine_model: [], // store 에서 받을 수 있는 machine code 들
      request_list : [],
      showScanBtn: true,
    };


    this._sendTool = this._sendTool.bind(this);
  }
  componentDidMount() {
    // request list 중 하나가 선택되어서 state 랑 함께 넘어왔을 경우 
    if ( this.props.location.state !== undefined && this.props.location.state.branchRecordId !== ""){
      // setState 
      this.setState({
        courierNumber : this.props.location.state.courier_number,
        courierNumber2 : this.props.location.state.courier_number2,
        branchRecordId : this.props.location.state.branchRecordId,
        request_list : this.props.location.state.request_list,
        // machine_model : this.props.location.state.machine_model,
        storeId : this.props.location.state.storeId, 
        storeName : this.props.location.state.storeName,
        //bag_id : this.props.location.state.bag_id,
        showScanBtn: false,
      }, ()=>{
        // selected request list styling 
        document.getElementById('list-'+this.state.branchRecordId).classList.add('active') 
        // make readonly input
        document.getElementById('courier_1').readOnly = true;
        document.getElementById('courier_2').readOnly = true;

      })

      

    }
  }

  async _sendTool() {
    //bag_id
    const { storeId, branchId, branchRecordId, courierNumber, courierNumber2, toolId } = this.state;
    let send = {};

    this.setState({ errMsg: "" });
    /*if (bag_id === '' || bag_id === null){
      this.setState({ errMsg: "Please enter the bag id." });
      return false;
    }*/
    if (this.state.showCourier) {
      // courier 선택시
      // check: storeId, courierNumber required 
      if (!storeId || !courierNumber) { return alert("Please enter courier number and select the store to receive the machine."); }
      // send 
      send = await sendTool({
        storeId,
        branchId: null,
        courierNumber,
        courierNumber2,
        branchRecordId,
        toolId/*,
        bag_id,*/
      });
    } else {
      // branch 선택시
      if (!branchId) { return alert("Please select the branch.");}
      // send 
      send = await sendTool({
        storeId,
        branchId,
        courierNumber: null,
        courierNumber2: null,
        branchRecordId: null,
        toolId/*,
        bag_id,*/
      });
    }
    if (send.success === true) {
      this.setState({ assignSuccess: true });
    } else {
      this.setState({ assignSuccess: false, errMsg: send.message });
    }
  }

  async _searchStores(storeName) {
    let { data } = (await searchStores(storeName)).data;
    return data.map(store => ({ value: store.id, label: store.name, machine_model : store.machine_model, request_list : store.branch_record_request}));
  }

  async _searchBranches(branchName) {
    let data = await searchBranches(branchName);
    return data.map(branch => ({ value: branch.id, label: branch.name }));
  }

  render() {
    return View.call(this);
  }

  _renderRequestListTool( { id, type,courier_number, courier_number2 }, key){
    return ( type === 'Tool' && 
      <a key={key} id={`list-`+id} data-id={id} className="request_item" onClick={event => {
        // 선택된 객체인지 체크 (선택되었으면 class='active')
        if(event.currentTarget.classList.length === 1){

          // 다른아이템 선택 해제
          let allItems= document.getElementsByClassName('request_item');
          for(var i = 0 ; i< allItems.length ; i++){
            allItems[i].classList.remove('active');
          }

          // 새로 선택됨
          event.currentTarget.classList.add('active') // selected request list active : border color change
          // make readonly input
          document.getElementById('courier_1').readOnly = true;
          document.getElementById('courier_2').readOnly = true;
  
          this.setState({
            courierNumber: courier_number,
            courierNumber2: courier_number2,
            branchRecordId: event.currentTarget.getAttribute('data-id'),
            showScanBtn : false,
          });
        }else{
          // 선택 해제할 경우
          // 다른아이템 선택 해제
          let allItems= document.getElementsByClassName('request_item');
          for(var j = 0 ; j< allItems.length ; j++){
            allItems[j].classList.remove('active');
          }
          event.currentTarget.classList.remove('active') // selected request list active : border color change
          // make readonly input
          document.getElementById('courier_1').readOnly = false;
          document.getElementById('courier_2').readOnly = false;
          
          this.setState({
            courierNumber: '',
            courierNumber2: '',
            branchRecordId: '',
            showScanBtn : true,
          })
        }
        
      }
      }>
        <strong>{this.state.storeName}</strong>
        Outgoing : <b>{courier_number}</b><br />
        Incoming : <b>{courier_number2}</b>
      </a>
    )
  }
}

export default withRouter(SendTool);



// WEBPACK FOOTER //
// ./src/screens/send_tool/index.js